import React, { useState, useEffect } from "react";
import authStorage from "../../utils/authStorage";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, CardElement, PaymentElement } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import axios from "axios";
import { BASE_URL } from "../../config";

// const stripePromise = loadStripe("pk_test_1AZtjtpnxCLoSvGb1DP48yP2");
//const stripePromise = loadStripe("pk_live_P1FhfWoh7B5aEP7ycjFGbrBE");
const stripePromise = loadStripe("pk_test_51N66M3SD7QKOKH3BjS6sufqdUyjfq1jiM8bsm5AerUAHUIoJOatJw0LEhc2WBNtv3lqp13mkXQaMtZkR19aDEk3t001hb1ZdmK");

const StripePaymentTraining = ({ setPaymentPage, setPaymentPageLoaded, paymentType, sesno }) => {
    const appearance = {
        theme: 'stripe',
        variables: {
            colorPrimary: '#26455A',
            colorBackground: '#fff',
            colorText: '#000',
            colorDanger: '#df1b41',
            fontFamily: 'Ideal Sans, system-ui, sans-serif',
            spacingUnit: '3.5px',
            borderRadius: '0px',
            border: '1px solid #ffffff38'
        }
    };

    const [clientSecret, setClientSecret] = useState('');
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [paymentIntent, setPaymentIntent] = useState('');
    const [options, setOptions] = useState({});

    useEffect(() => {
        if (!paymentType) {
            return;
        }
        // Create PaymentIntent as soon as the page loads
        axios({
            url: `${BASE_URL}/auth/create/onetime/app-payment-intent`,
            method: "POST",
            headers: {
                "x-access-token": authStorage.getItem("auth-token")
            },
            data: { paymentType },
        }).then((data) => {

            setClientSecret(data?.data?.clientSecret);
        });
    }, [paymentType]);

    return (
        <div className="pt-6 px-4 ">
            {clientSecret && (
                <Elements
                    stripe={stripePromise}
                    options={{
                        appearance,
                        clientSecret,
                    }}
                >
                    <CheckoutForm
                        setName={setName}
                        name={name}
                        setEmail={setEmail}
                        email={email}
                        paymentType={paymentType}
                        sesno={sesno}
                        setPaymentPage={setPaymentPage}
                        clientSecret={clientSecret}
                        paymentIntent={paymentIntent}
                    />
                </Elements>
            )}
        </div>
    );
}

export default StripePaymentTraining;
